module.exports = __webpack_public_path__ + "static/img/sport_2.4b14d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport_2.png
// module id = lHLO
// module chunks = 0